<ng-container>
	@if (!client()) {
	<div></div>
	} @else {
	<div class="push-bottom-md">
		<lib-card>
			<div>
				<ui-text-area-form-field
					[placeholder]="'Type a message'"
					[valueAsSignal]="message"
					[enableEmoji]="true"
					[enableGenAi]="true"
					[genAiClientContext]="client()"
				></ui-text-area-form-field>
			</div>
			<div class="push-top">
				<ui-form-save-button
					[removeDivider]="true"
					[title]="'Send'"
					[saveHandler]="saveHandler()"
					[logHandler]="formLogHandler()"
					[enableControlEnterSaveShortcut]="true"
				></ui-form-save-button>
			</div>
		</lib-card>
	</div>

	@if (chatMessages()?.length === 0) {
	<div>
		<lib-message [type]="'noDataOnBody'">You have no messages yet</lib-message>
	</div>
	} @if (chatMessages()?.length) {
	<lib-card>
		@for ( chatMessage of chatMessages(); track chatMessage.id; let first = $first; let last = $last) {
		<div [class.push-top-md]="!first">
			<div>
				<div libFlexRow [libFlexRowGap]="'16px'" [libFlexRowAlign]="'center'">
					<div libFlexColumn [libFlexSize]="'50px'">
						<lib-image
							[image]="chatMessage.avatar"
							[avatarName]="chatMessage.name"
							[imageSize]="'50px'"
							[alt]="'User avatar'"
						></lib-image>
					</div>
					<div libFlexColumn libFlexFill>
						<div [libText2]="true" libWordBreak>
							{{ chatMessage.name }}
						</div>
						<div libFlexColumn libText5>
							{{ chatMessage.date }}
						</div>
					</div>
				</div>
				<div class="w-message push-top-sm" libWordBreak>
					<div libText1 [innerHTML]="chatMessage.message | textToHtml"></div>
				</div>
				@if (!last) {
				<lib-divider class="push-top push-bottom"></lib-divider>
				}
			</div>
		</div>
		}
	</lib-card>
	} }
</ng-container>
